import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Collapse,
  Container,
  Input,
  FormGroup,
  Label,
  Row,
  UncontrolledTooltip } from 'reactstrap';
import NumberFormat from 'react-number-format';

class PersonifyIncome extends Component {
  state = {
    incomeSource: ''
  }

  onIncomeChange = (event) => {
    this.setState({ incomeSource: event.target.value });
  }

  formatCurrency = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  })

  renderIncomeSource = (incomeSource) => {
    if (incomeSource === 'employment') {
      return (
        <CardBody className="pt-0 pb-1">
          <FormGroup>
            <Label for="companyName">Company Name or Description</Label>
            <Input type="text" name="company-name" id="companyName" />
          </FormGroup>
          <FormGroup>
            <Label for="monthlyIncome">Monthly income after taxes</Label>
            <Input
              type="tel"
              name="monthly-income"
              id="monthlyIncome"
              tag={NumberFormat}
              thousandSeparator={true}
              prefix={'$'}
              onChange={this.handleRefundChange}
            />
          </FormGroup>
          <FormGroup>
            <Label for="incomePeriod">How long earning from this source?</Label>
            <Input type="select" name="income-period" id="incomePeriod">
              <option>Select One...</option>
              <option>0 to 3 Months</option>
              <option>3 to 6 Months</option>
              <option>6 to 12 Months</option>
              <option>1 to 2 Years</option>
              <option>2+ Years</option>
            </Input>
          </FormGroup>
          <FormGroup>
            <Label for="mainIncomeSource">How often do you get paid?</Label>
            <Input type="select" name="main-income-source" id="mainIncomeSource">
              <option>Select One...</option>
              <option>Every other week</option>
              <option>Once a month</option>
              <option>Twice a month</option>
              <option>Once a week</option>
              <option>Other</option>
            </Input>
          </FormGroup>
        </CardBody>
      )
    } else if (incomeSource === 'self-employment') {
      return (
        <CardBody className="pt-0 pb-1">
          <FormGroup>
            <Label for="companyName2">Company Name or Description</Label>
            <Input type="text" name="company-name2" id="companyName2" />
          </FormGroup>
          <FormGroup>
            <Label for="monthlyIncome2">Monthly income after taxes</Label>
            <Input
              type="tel"
              name="monthly-income2"
              id="monthlyIncome2"
              tag={NumberFormat}
              thousandSeparator={true}
              prefix={'$'}
              onChange={this.handleRefundChange}
            />
          </FormGroup>
          <FormGroup>
            <Label for="incomePeriod2">How long earning from this source?</Label>
            <Input type="select" name="income-period2" id="incomePeriod2">
              <option>Select One</option>
              <option>0 to 3 Months</option>
              <option>3 to 6 Months</option>
              <option>6 to 12 Months</option>
              <option>1 to 2 Years</option>
              <option>2+ Years</option>
            </Input>
          </FormGroup>
          <FormGroup>
            <Label for="mainIncomeSource">How often do you get paid?</Label>
            <Input type="select" name="main-income-source" id="mainIncomeSource">
              <option>Select One...</option>
              <option>Every other week</option>
              <option>Once a month</option>
              <option>Twice a month</option>
              <option>Once a week</option>
              <option>Other</option>
            </Input>
          </FormGroup>
        </CardBody>
      )
    } else if (incomeSource === 'retired-benefits') {
      return (
        <CardBody className="pt-0 pb-1">
          <FormGroup>
            <Label for="companyName3">Description</Label>
            <Input type="text" name="company-name3" id="companyName3" />
          </FormGroup>
          <FormGroup>
            <Label for="monthlyIncome3">Monthly income after taxes</Label>
            <Input
              type="tel"
              name="monthly-income3"
              id="monthlyIncome3"
              tag={NumberFormat}
              thousandSeparator={true}
              prefix={'$'}
              onChange={this.handleRefundChange}
            />
          </FormGroup>
          <FormGroup>
            <Label for="incomePeriod3">Income for next 3 years?</Label>
            <Input type="select" name="income-period3" id="incomePeriod3">
              <option>Select One</option>
              <option>Yes</option>
              <option>No</option>
            </Input>
          </FormGroup>
          <FormGroup>
            <Label for="incomePeriod4">Approximate income end date?</Label>
            <Input type="date" name="income-period4" id="incomePeriod4" />
          </FormGroup>
          <FormGroup>
            <Label for="mainIncomeSource">How often do you get paid?</Label>
            <Input type="select" name="main-income-source" id="mainIncomeSource">
              <option>Select One...</option>
              <option>Every other week</option>
              <option>Once a month</option>
              <option>Twice a month</option>
              <option>Once a week</option>
              <option>Other</option>
            </Input>
          </FormGroup>
        </CardBody>
      )
    } else if (incomeSource === 'other') {
      return (
        <CardBody className="pt-0 pb-1">
          <FormGroup>
            <Label for="companyName3">Description</Label>
            <Input type="text" name="company-name3" id="companyName3" />
          </FormGroup>
          <FormGroup>
            <Label for="monthlyIncome3">Monthly income after taxes</Label>
            <Input
              type="tel"
              name="monthly-income3"
              id="monthlyIncome3"
              tag={NumberFormat}
              thousandSeparator={true}
              prefix={'$'}
              onChange={this.handleRefundChange}
            />
          </FormGroup>
          <FormGroup>
            <Label for="mainIncomeSource">How often do you get paid?</Label>
            <Input type="select" name="main-income-source" id="mainIncomeSource">
              <option>Select One...</option>
              <option>Every other week</option>
              <option>Once a month</option>
              <option>Twice a month</option>
              <option>Once a week</option>
              <option>Other</option>
            </Input>
          </FormGroup>
        </CardBody>
      )
    }
  }

  render() {
    const { incomeSource } = this.state;

    return (
      <div className="page-personify">
        <Container>
          <Row>
            <Col md={9} lg={5} className="text-center mb-4 mt-2 ml-auto mr-auto">
              <h2>Just a few more questions</h2>
            </Col>
          </Row>
          <Row>
            <Col md={9} lg={5} className="ml-auto mr-auto">
              <Card>
                <CardHeader className="has-tooltip">
                  <h4 className="mb-0">What is your <strong>main source</strong> of income?</h4>
                  <span className="tip-icon" id="mainIncomeTooltip"></span>
                  <UncontrolledTooltip placement="top" target="mainIncomeTooltip">
                    You will be able to add additional sources of income later
                  </UncontrolledTooltip>
                </CardHeader>
                <CardBody>
                  <FormGroup>
                    <Label for="mainIncomeSource">Main Source of Income</Label>
                    <Input type="select" name="main-income-source" id="mainIncomeSource" value={incomeSource} onChange={this.onIncomeChange}>
                      <option value="">Select One...</option>
                      <option value="employment">Employment</option>
                      <option value="self-employment">Self-Employment</option>
                      <option value="retired-benefits">Retired/Benefits</option>
                      <option value="other">Other</option>
                    </Input>
                  </FormGroup>
                  <small className="text-center">Note: Alimony, child support, or separate maintenance income need not be revealed if you do not wish to have it considered as a basis for repaying the loan.</small>
                </CardBody>
                <Collapse isOpen>
                  {this.renderIncomeSource(incomeSource)}
                </Collapse>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md={9} lg={5} className="ml-auto mr-auto mb-4">
              <Button className="w-100">Add additional income</Button>
            </Col>
          </Row>
          <Row>
            { incomeSource !== '' &&
              <Col md={9} lg={5} className="ml-auto mr-auto">
                <Button tag={Link} to="/personify/approved" color="personify" size="lg" className="w-100">Continue</Button>
              </Col>
            }
          </Row>
        </Container>
      </div>
    )
  }
}

export default PersonifyIncome;
